module.exports = __webpack_public_path__ + "img/gsjj.fdfe4bd3.png";